var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/*tslint:disable*/
import React from "react";
import { useUser } from "@atlassiansox/microscopekit";
import Button from "@atlaskit/button";
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
import { akColorN200 as N200 } from "@atlaskit/util-shared-styles";
import styled from "styled-components";
import { SSHDropdown } from "./ssh-dropdown";
import { getDeploymentId, getEnv, isDeploymentComplete, deploymentStatus, sshProxyUrls, } from "../utils";
import { TabLink } from "./tab-link";
var _a = require("@atlaskit/page"), Grid = _a.Grid, GridColumn = _a.GridColumn;
var Lozenge = require("@atlaskit/lozenge").default;
var PanelContentContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px;\n  flex: 1 0 auto;\n"], ["\n  padding: 20px;\n  flex: 1 0 auto;\n"])));
var LinkColumn = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 3em;\n"], ["\n  margin-left: 3em;\n"])));
export var PanelContent = function (_a) {
    var id = _a.id, deploymentType = _a.deploymentType, status = _a.status, creationTime = _a.creationTime, splunkURL = _a.splunkURL, label = _a.label, microsEnv = _a.microsEnv, team = _a.team, trafficPercentage = _a.trafficPercentage, accountId = _a.accountId;
    var user = useUser();
    var deploymentId = getDeploymentId(id);
    var type = deploymentType === "persistent" || deploymentType === "other"
        ? deploymentType + "-" + deploymentId
        : deploymentType;
    var env = getEnv(id);
    return (React.createElement(PanelContentContainer, null,
        React.createElement(Grid, { layout: "fluid" },
            React.createElement(GridColumn, { medium: 3 },
                React.createElement("p", null, "Deployment Status:"),
                React.createElement("p", null, "Traffic Percentage:"),
                React.createElement("p", null, "Deployment ID:"),
                React.createElement("p", null, "Creation Timestamp:"),
                React.createElement("p", null, "Account Id:")),
            React.createElement(GridColumn, { medium: 6 },
                React.createElement("p", null,
                    React.createElement(Lozenge, { isBold: true, appearance: deploymentStatus(status), children: status })),
                React.createElement("p", null,
                    trafficPercentage,
                    "%"),
                React.createElement("p", null, deploymentId),
                React.createElement("p", null, creationTime),
                React.createElement("p", null, accountId)),
            React.createElement(GridColumn, { medium: 3 },
                React.createElement(LinkColumn, null,
                    splunkURL && (React.createElement(Button, { appearance: "link", href: splunkURL, target: "_blank", iconAfter: React.createElement(ShortcutIcon, { label: "Splunk", size: "small", primaryColor: N200 }) }, "Splunk")),
                    React.createElement(React.Fragment, null,
                        React.createElement(TabLink, { name: "service-descriptor", label: label, microsEnv: microsEnv, type: type, text: "Service Descriptor" }),
                        React.createElement(TabLink, { name: "logs", label: label, microsEnv: microsEnv, type: type, text: "Deployment Logs" }),
                        React.createElement(TabLink, { name: "aliases", label: label, microsEnv: microsEnv, type: type, text: "Aliases" })))),
            isDeploymentComplete(status) &&
                sshProxyUrls.has(env) &&
                team.includes(user.username) && (React.createElement(GridColumn, { medium: 7 },
                React.createElement(SSHDropdown, { deploymentId: id, env: env, deploymentType: deploymentType }))))));
};
export var PanelContentComponent = PanelContent;
PanelContentComponent.displayName = "PanelContent";
var templateObject_1, templateObject_2;
